
import Vue from 'vue';
import { WithContext, Product } from 'schema-dts';
  import FaqCard from '@/components/FaqCard';
  import PageHeader from '@/components/core/PageHeader';
  import tableLoading from '@/components/tableLoading';
  export default {
    scrollToTop: true,
    head() {
      return {
        title: this.title + " | Goa App",
        meta: [{
            hid: 'og:title',
            property: 'og:title',
            content: this.title + " | Goa App"
          },
          {
            hid: 'twitter:title',
            property: 'twitter:title',
            content: this.title + " | Goa App"
          }
        ],
      }
    },
    jsonld() {
    const items = this.faqData.map((item, index) => ({
      '@type': 'Question',
      position: index + 1,
      "name":item.question,
      "acceptedAnswer": {
          "@type": "Answer",
          "text":  item.answer
        },
    }));
    return {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
       mainEntity: items,
    };
  },
    components: {
      FaqCard,
      PageHeader,
      tableLoading
    },
    data() {
      return {
        title: 'FAQ',
        faqData: [],
        search: '',
        loading: true,
      }
    },
    layout: 'transparent-nav',
    fetchOnServer: false,
    async fetch() {
      //Get the list of page data
      this.faqData = await fetch(this.$config.fetchUrl + '/api/faqs/app/getFeatured').then(res =>
        res.text());
        this.faqData = this.getCryptKey(this.faqData);
      this.$nextTick(() => {
        this.loading = false;
      })
    },

    computed: {
      // Used for search function on the page
      filteredFaqList() {
        if (this.faqData) {
          return this.faqData.filter(faq => {
            return (faq.question.toLowerCase().includes(this.search.toLowerCase().trim()) || faq.answer
            .toLowerCase().includes(this.search.toLowerCase().trim()))
          })
        } else {
          return []
        }
      }
    }

  }

